// test1472
(1472 && 0);
